<!-- The ref attr used to find the swiper instance -->
<template>
  <swiper
    :options="swiperOption"
    :global-options="globalOptions"
    ref="mySwiper"
  >
    <!-- slides -->
    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          TORBEL es una empresa que se caracteriza por la responsabilidad, la
          puntualidad y sobretodo un seguimiento, trato especial y personalizado
          a cada uno de sus clientes, brindan un servicio ejemplar a través de
          su equipo altamente profesional. Para las empresas de Martí Petroleum
          Group, el apoyo y la calidad de los trabajos realizados por TORBEL son
          de suma importancia, es por esto que hemos depositado nuestra
          confianza plena en ellos, que siempre están atentos a cada detalle, a
          cada punto, siempre al día, siempre disponibles, siempre brindando una
          solución.
        </p>
        <div class="quotes--foot">
          <strong>Alexandra Gärtner</strong>
          <p>
            Directora Legal Marti
          </p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          La dedicación TORBEL al cumplimiento de los objetivos de cada proyecto
          que le hemos asignado, su atención meticulosa a cada detalle, actuando
          con capacidad, profesionalismo y compromiso son cualidades que he
          apreciado particularmente durante nuestra colaboración.
        </p>
        <div class="quotes--foot">
          <strong>Luis A. Taveras</strong>
          <p>
            Asesor Consejo de Directores Grupo Propagas
          </p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          Desde Grupo Ramos, queremos expresar nuestra gratitud y satisfacción
          por el trabajo que TORBEL ha realizado para nuestra empresa. Los
          servicios brindados nos han ayudado a cumplir con nuestras
          obligaciones legales y éticas. Su compromiso con la gestión ambiental
          se refleja en cada proyecto que han llevado a cabo para nuestra
          empresa, proporcionándonos soluciones efectivas para nuestras
          necesidades específicas.
        </p>
        <div class="quotes--foot">
          <strong>Flora Paola Carrion</strong>
          <p>Coordinadora de Tramitación de Permisos – Grupo Ramos</p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          Encontrar empresas respaldadas por profesionales competentes en el
          área ambiental en la Republica Dominicana es un reto. En TORBEL hemos
          encontrado el apoyo necesario para desarrollar nuestro sistema de
          gestión ambiental y mejorarlo continuamente.
        </p>
        <div class="quotes--foot">
          <strong>Ing. Julián Rojas López</strong>
          <p>
            HSSE Manager Dom Rep, Jamaica & St. Maarten Gulfstream Petroleum
            Dominicana. – Texaco
          </p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          En TORBEL se respira excelencia desde el primer contacto. Muchas
          empresas nos habían visitado ofreciendo soluciones de iluminación
          similares. Ninguna cautivo mi atención como el equipo de Torbel. Su
          propuesta asertiva con números claros, el compromiso con dicha
          promesa, y su consecuente cumplimiento supero a sus homólogos en la
          industria. Sin duda uno de nuestros proveedores preferentes.
        </p>
        <div class="quotes--foot">
          <strong>Priscilla Velazquez</strong>
          <p>Marchand D’ Art, 10 Artesanos</p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          Hacemos constar por este medio nuestra satisfacción con la calidad del
          servicio de Torbel en las distintas áreas del negocio que tenemos
          interacción. Es muy notable el profesionalismo de sus equipos de
          trabajo, así como el compromiso de los mismos con la calidad de la
          ejecución y apego a los estándares de Seguridad, Salud y Protección al
          Medio Ambiente durante la realización de las distintas actividades.
          Para nosotros Torbel representa un “asociado estratégico” que comparte
          los valores de Sol Petroleum en la manera de manejar sus actividades
          de negocio.
        </p>
        <div class="quotes--foot">
          <strong>Freddy González</strong>
          <p>
            Gerente de Operaciones <br />
            ESSO REPUBLICA DOMINICANA S.R.L.
          </p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-width-md slide-layout-quotes">
        <p class="quotes--content">
          He tenido el placer de trabajar de la mano con la empresa Torbel
          durante más de 5 años, recibiendo calidad y dominio en materia de
          producción, ejecución e instalación de letreros exteriores para
          nuestras estaciones de servicio. Dicha empresa está conformada por un
          equipo de profesionales comprometidos y expertos en el área, los
          cuales han jugado un rol importante en el crecimiento y
          posicionamiento de la marca, ofreciendo propuestas y recomendaciones
          acertadas. Torbel se destaca por su calidad, seguimiento exhaustivo y
          cumplimiento en los tiempos prometidos.
        </p>
        <div class="quotes--foot">
          <strong>Karla Rivas</strong>
          <p>
            Gerente de Mercadeo<br />
            Distribuidores Internacionales de Petróleo, DIPSA
          </p>
        </div>
      </div>
    </swiper-slide>

    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'carrousel',
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // current swiper instance
    this.swiper.slideTo(3, 1000, true);
  },
};
</script>

<style lang="scss">
.swiper-wrapper {
  align-items: center;
}

.slide-layout-quotes {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-size: $extra-small-font-size;

  @media (max-width: 1280px) {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 3.5rem; // leave room for nav arrows
  }

  .quotes--content {
    margin-bottom: 3rem;
    font-size: $medium-font-size;

    @media (max-width: 768px) {
      font-size: $small-font-size;
    }
  }
  .quotes--foot {
    margin: 0 auto;
  }
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0px;
}
.swiper-pagination-bullet {
  width: 12px !important;
  height: 12px !important;
  background: #e3e3e3;
  opacity: 0.8;
}
.swiper-pagination-bullet-active {
  background: $primary-color !important;
}

/* Swiper navigation arrows (mobile was looking oversized / overlapping content) */
.swiper-button-prev,
.swiper-button-next {
  width: 28px;
  height: 28px;
  top: 50%;
  transform: translateY(-50%);
  color: $primary-color;
  opacity: 0.9;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 28px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .swiper-button-prev,
  .swiper-button-next {
    width: 22px;
    height: 22px;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 22px;
  }
}
</style>
